import { AfterViewInit, Component, OnInit } from '@angular/core';

import { ProplayerService } from '../../shared/services/proplayer.service';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription, switchMap, timer } from 'rxjs';
import { PieceIconPipe } from '../../shared/pipes/piece-icon.pipe';
import { DecryptionService } from '../../shared/services/decryption.service';
@Component({
  selector: 'app-openings',
  standalone: true,
  templateUrl: './openings.component.html',
  styleUrl: './openings.component.scss',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, PieceIconPipe],
})
export class OpeningsComponent implements OnInit {
  pageNumber = 1;
  isLoading!: boolean;
  playerdetails: any;
  protected openingFilters!: FormGroup;
  openingRecord: any[] = [];
  openingfilterData = '';
  openingfilterEco = '';
  currentMoveIndex = 0;
  recordDataMove: any;
  lastIndexGame: any;
  historyGameMove!: string[];
  openingsuggestions: any[] = [];
  openingName: any;
  suggestionsection!: boolean;
  private openingSearch?: Subscription;
  constructor(
    private openingApi: ProplayerService,
    private fb: FormBuilder,
    private router: Router, private decryptionApi: DecryptionService
  ) { }

  ngOnInit(): void {
    this.openingFilters = this.fb.group({
      name: [''],
      eco: [''],
    });
    this.openingdetail();
  }

  openingdetail() {
    this.isLoading = true;
    this.openingApi
      .openingsData(
        this.pageNumber,
        this.openingfilterEco,
        this.openingfilterData
      )
      .subscribe({
        next: (res) => {
          const decrypt = this.decryptionApi.decrypt(res.payload);
          const jsondecrpt = JSON.parse(decrypt);
          this.playerdetails = jsondecrpt;
          this.isLoading = !this.playerdetails;
          this.openingRecord.push(...this.playerdetails);
          this.recordDataMove = this.openingRecord[0];
        },
      });
  }

  filterData(data: any) {
    this.openingRecord = [];
    this.pageNumber = 1;
    if (data.name) {
      this.openingfilterData = data.name;
    }
    this.openingfilterEco = data.eco;
    this.openingdetail();
  }

  formReset() {
    this.openingFilters.reset();
    this.openingfilterEco = '';
    this.openingfilterData = '';
    this.openingRecord = [];
    this.pageNumber = 1;
    this.openingdetail();
  }

  onScroll(event: any) {
    const element = event.target as HTMLElement;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const totalHeight = element.scrollHeight;
    if (this.playerdetails.length == 0 || this.playerdetails.length < 20) {
      return;
    }

    if (scrollPosition >= totalHeight - 1 && !this.isLoading) {
      this.isLoading = true;
      this.pageNumber++;
      this.openingdetail();
    }
  }

  openingSelectData(data: any) {
    this.router.navigate(['openingdetails', data._id]);
  }

  playerInputChanges(data: any) {
    if (this.openingSearch) {
      this.openingSearch.unsubscribe();
    }
    this.openingName = data.target.value;
    this.openingSearch = timer(1000)
      .pipe(
        switchMap(() => this.openingApi.openingsuggestionData(this.openingName))
      )
      .subscribe({
        next: (res) => {
          const decrypt = this.decryptionApi.decrypt(res.payload);
          const jsondecrpt = JSON.parse(decrypt);
          this.openingsuggestions = jsondecrpt;
        },
        error: (err) => { },
      });
  }

  suggestionValue(data: string) {
    this.openingName = data;
    this.openingsuggestions = [];
  }
}
